<template>
    <div>
        <check-list :listArray="listArray"></check-list>
    </div>
</template>
<script>
    import CheckList from './check/checkList.vue';

    export default {
        data () {
            return {
                listArray: [
                    {icon:'far fa-check-circle', title:'iOS', text:'אפליקצית iOS מותאמת ל App Store ומעוצבת בהתאם לסטנדרט המחמיר של אפל.'},
                    {icon:'far fa-check-circle', title:'Android', text:'אפליקצית Android מותאמת ל Google Play ומעוצבת בהתאם לסטנדרט של גוגל ולעקרונות ה material design.'},
                    {icon:'far fa-check-circle', title:'מהירות וביצועים', text:'מהירות וביצועים בהתאם לסטנדרטים של לקוחותכם המחזיקים במכשירים החדשים בשוק ורגילים ש"זה טס".'},
                    {
                        icon:'far fa-check-circle',
                        title:'עיצוב מותאם אישית ללא פשרות',
                        text:'חשוב לנו להביא לידי ביטוי את אופי החברה שלכם ולגרום לאפליקציה לשדר בדיוק את מה שאתם מעוניינים לשדר.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'קשר עם הלקוח',
                        text:'קשר נוח ובריא עם הלקוחות יביא אתכם להצלחה. כל מערכת שלנו מצויידת בטופס יצירת קשר מתקדם ובקישורים בולטים לעמודים שלכם ברשתות החברתיות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'חיפוש עוצמתי שמבין את המשתמש',
                        text:'מערכת החיפוש המהירה, המדויקת והמתקדמת בשוק תאפשר ללקוחות שלכם למצוא כל דבר בשניות בודדות.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'ממשק משתמש אינטואיטיבי ופשוט',
                        text:'יאפשר ללקוחות שלכם להרגיש בבית וימקד אותם על התהליכים המרכזיים באפליקציה.'
                    },
                    {
                        icon:'far fa-check-circle',
                        title:'אבטחה',
                        text:'ניהול משתמשים ומידע מוצפן ומאובטח אשר יגן על פרטיות משתמשכם.'
                    },
                ],
            }
        },
        components: {
            'check-list': CheckList,
        }
    }
</script>
